import React, { Component } from 'react'
import './AboutMe.css'
import NavBar from '../navBar/navBar'
import Presentation  from '../presentation/Presentation'
import Skills from '../skills/Skills'
import Projects from '../projects/Projects'
import ContactMe from '../contact_me/ContactMe'
import Articles from '../articles/Articles'
import ReactGA from 'react-ga';
import Google_Analytics from '../../const/Google_Anlytics'

export default class AboutMe extends Component {

    componentDidMount() {
        
       ReactGA.initialize(Google_Analytics.Tracking_Id);
       ReactGA.pageview('Wejdi Gharbi- About Screen');
    
     }

    render() {
        return (
            <div>
                <NavBar/>
                <Presentation />  
                <Skills />  
                <Projects />
                <Articles/>
                <ContactMe />
               
            </div>
        )
    }
}
